import {
  Lead,
  Message,
} from "../../../../../../pages/Communications/utils/types";
import VerbachatIcon from "../../../../../../assets/svg/verbachat-icon";
import VerbamessengerIcon from "../../../../../../assets/svg/verbamessenger-icon";

export const transformLeadList = (
  lead: Lead,
  communicationMode: { value: string },
  currentLead?: Lead | null
) => {
  const sessionCount = currentLead
    ? (currentLead?.sessionCount || 0) + (lead.session_count || 0)
    : lead.session_count || 0;
  const messageCount = currentLead
    ? (currentLead?.messageCount || 0) + (lead.message_body_count || 0)
    : lead.message_body_count || 0;
  return {
    ...lead,
    leadId: lead.lead_id,
    leadName: lead?.created_by_name || lead?.name || "Anonymous",
    name: lead?.created_by_name || "Anonymous",
    isOnline:
      communicationMode.value === "email"
        ? false
        : lead.is_online_on_whatsapp ||
          lead.is_online_on_widget ||
          lead.is_online_on_fb_messenger ||
          lead.is_online_on_instagram,
    outboundModalities: lead.outbound_channel_tracking || {},
    inboundModalities: lead.channel_tracking || {},
    isHumanAssisted: lead.agent_override,
    sourceCountry: lead.source_country_alpha2,
    latestMessage: lead.latest_chat,
    isSecondaryLead: lead.original_lead_id ? true : false,
    sessionCount: sessionCount,
    messageCount: messageCount,
    hasFeedback: lead?.feedback?.average_score || 0,
    timestamp: lead?.latest_chat_timestamp,
    dislikedCount: lead?.total_number_of_dislikes || 0,
    likedCount: lead?.total_number_of_likes || 0,
    flaggedCount: lead?.total_flagged_response || 0,
  };
};

export const transformTestingMessage = (message: Message, channel?: string) => {
  return {
    ...message,
    id: message.message_id,
    message_id: message.message_id,
    content: message.content,
    transcript_text: message.transcript_text,
    role: message.role,
    kind: message.kind,
    timestamp: message.timestamp,
    language: message.language,
    attachments: message.attachments,
    template_meta_data: message.template_meta_data,
    channel: channel || message.channel,
    aiResponseTime: message.ai_response_time_in_seconds,
  };
};

export const PLAYGROUND_TESTING_MODALITIES_OPTIONS = [
  {
    value: "widget",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbachatIcon className="w-[18px] h-[18px] text-verba-chat dark:text-verba-chat-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaChat
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Chat communications
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbachatIcon className="w-[14px] h-[14px] text-verba-chat dark:text-verba-chat-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaChat
        </h3>
      </div>
    ),
  },

  {
    value: "whatsapp",
    content: (
      <div className="flex items-center gap-[10px]">
        <VerbamessengerIcon className="w-[18px] h-[18px] text-verba-messenger dark:text-verba-messenger-dk" />
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            VerbaMessenger
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            WhatsApp communication
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <VerbamessengerIcon className="w-[14px] h-[14px] text-verba-messenger dark:text-verba-messenger-dk" />
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          VerbaMessenger
        </h3>
      </div>
    ),
  },
  // {
  //   value: "call",
  //   content: (
  //     <div className="flex items-center gap-[10px]">
  //       <VerbacallIcon className="w-[18px] h-[18px] text-verba-lavender dark:text-verba-lavender-dk" />
  //       <div>
  //         <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
  //           VerbaCall
  //         </h3>
  //         <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
  //           Call communication
  //         </p>
  //       </div>
  //     </div>
  //   ),
  //   selectedOptionContent: (
  //     <div className="flex items-center gap-[4px]">
  //       <VerbacallIcon className="w-[14px] h-[14px] text-verba-lavender dark:text-verba-lavender-dk" />
  //       <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
  //         VerbaCall
  //       </h3>
  //     </div>
  //   ),
  // },
];

export const TESTING_CONFIG = {
  FLAG_MODAAL: {
    HEADER: {
      TITLE: "Flag this response",
      DESCRIPTION: "Help us understand what’s wrong with this response",
    },
  },
  FLAG_INBOX_HEADER: {
    TITLE: "Flagged Messages",
    DESCRIPTION:
      "Flagged messages have been detected in this conversation, Please review them.",
  },
  FLAG_GLOBAL_HEADER: {
    TITLE: "Flagged Responses",
    TOTAL_FLAGGED_RESPONSES: "Total Flagged Responses",
    THIS_WEEK: "Last 7 Days",
  },
  AI_RESPONSE_TIME: "AI Response Time:",
  USER_RESPONSE_TIME: "User Response Time:",
  RECENT_CHATS_HEADER: "Recent Chats",
  NO_MESSAGES_FOUND: "No messages found",
  START_NEW_CHAT_HEADER: "Start a new chat from scratch",
};

export const REASON_OPTIONS = [
  {
    value: "Spam",
    content: (
      <div className="flex items-center">
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Spam
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
          The response is identified as spam or irrelevant messages.
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
        Spam
        </h3>
      </div>
    ),
  },
  {
    value: "Inaccurate or misleading",
    content: (
      <div className="flex items-center">
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Inaccurate or misleading
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk text-nowrap">
            This information is factually wrong or confusing.
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          Inaccurate or misleading
        </h3>
      </div>
    ),
  },

  {
    value: "Inappropriate or harmful",
    content: (
      <div className="flex items-center gap-[10px]">
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Inappropriate or harmful
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Contains offensive, unsafe or biased content.
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          Inappropriate or harmful
        </h3>
      </div>
    ),
  },
  {
    value: "Irrelevant or off-topic",
    content: (
      <div className="flex items-center gap-[10px]">
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Irrelevant or off-topic
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Dont answer my question or goes off track
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          Irrelevant or off-topic
        </h3>
      </div>
    ),
  },
  {
    value: "Low quality or unclear",
    content: (
      <div className="flex items-center gap-[10px]">
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Low quality or unclear
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            The explanation isn't useful, well written or coherent.
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          Low quality or unclear
        </h3>
      </div>
    ),
  },
  {
    value: "Privacy concern",
    content: (
      <div className="flex items-center gap-[10px]">
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Privacy concern
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Contains personal data or sensitive information.
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          Privacy concern
        </h3>
      </div>
    ),
  },
  {
    value: "other",
    content: (
      <div className="flex items-center gap-[10px]">
        <div>
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            Other
          </h3>
          <p className="text-xs font-normal text-dark-gray dark:text-dark-gray-dk">
            Something else is wrong.
          </p>
        </div>
      </div>
    ),
    selectedOptionContent: (
      <div className="flex items-center gap-[4px]">
        <h3 className="text-sm font-medium text-heading-text dark:text-heading-text-dk">
          Other
        </h3>
      </div>
    ),
  },
];
